'use client';

import { css } from '@onbeam/business-styled-system/css';
import { motion } from 'motion/react';

export const AppsCarouselPinger = () => (
  <div className={css({ position: 'relative', mb: '1' })}>
    <motion.div
      className={css({
        position: 'absolute',
        inset: '0',
        rounded: 'full',
        bg: 'green.30',
        _dark: {
          bg: 'green.0/80',
        },
      })}
      animate={{
        scale: [1, 3],
        opacity: [1, 0],
        transition: {
          duration: 0.7,
          ease: 'easeOut',
          repeat: Number.POSITIVE_INFINITY,
          repeatDelay: 1,
        },
      }}
    />
    <div
      className={css({
        bg: 'green.0',
        rounded: 'full',
        w: '[0.5rem]',
        h: '[0.5rem]',
        position: 'relative',
      })}
    />
  </div>
);
